import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectChildren: "[selectChildren] Action",
	selectChildrenLoad: "[selectChildrenLoad] Action",
	selectChildrenAsync: "[selectChildrenAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const select_children_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectChildren:
			return {
				...state,
				data: payload?.data?.results ? payload?.data?.results : [],
			};

		case actionTypes.selectChildrenLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({ type: actionTypes.selectChildrenLoad, payload: payload });
	let config = {
		url: "select_request",
	};

	let data = {
		table: "accounting",
		method_type: "select_children",
		data: payload?.data ? payload?.data : {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectChildren,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({ type: actionTypes.selectChildrenLoad, payload: false });
	}
}

export function* selectChildren() {
	yield takeEvery(actionTypes.selectChildrenAsync, handleWorker);
}
